import { dataTestId } from 'modules/experiments/constants';
import { VariantPill } from 'modules/experiments/components/ui/pills';
import { useVariantConfigurationContext } from 'modules/experiments/contexts';
import { SelectVariantMode } from 'modules/experiments/types';
import { useExperimentsTranslations } from 'modules/experiments/hooks';
import { Skeleton } from 'ui/skeleton';

import { Banner, PreviewBannerText, VariantName } from './Styled';

export const PreviewBanner = () => {
  const { addingNewVariant, deletingActiveVariant, selectedVariant, selectMode } =
    useVariantConfigurationContext();

  const { t } = useExperimentsTranslations();
  const previewBannerPreTextOptions = {
    [SelectVariantMode.PREVIEW]: t('previewBanner.preview'),
    [SelectVariantMode.EDIT]: t('previewBanner.edit'),
  };

  if (addingNewVariant || deletingActiveVariant)
    return (
      <div data-test={dataTestId.contentBanner}>
        <Skeleton height={44} />
      </div>
    );
  if (selectedVariant?.textColor && selectedVariant?.bgColor && selectedVariant?.alphabet)
    return (
      <Banner data-test={dataTestId.contentBanner}>
        <VariantPill textColor={selectedVariant.textColor} bgColor={selectedVariant.bgColor}>
          {selectedVariant.alphabet}
        </VariantPill>
        <PreviewBannerText
          data-test={dataTestId.contentBannerText}
          color={selectedVariant.textColor}
        >
          {previewBannerPreTextOptions[selectMode]}&nbsp;
          <VariantName>
            {selectedVariant?.name}
            {selectedVariant.control ? <>&nbsp;({t('previewBanner.control')})</> : null}
          </VariantName>
        </PreviewBannerText>
      </Banner>
    );
  return <div data-test={dataTestId.contentBanner} />;
};
